import { hasPermissions } from 'lib/auth'

const service = 'order'
const endpoint = 'v3/deliveryOrders'

export const hasOrderGetPermissions = () =>
  hasPermissions(service, endpoint, 'get')
export const hasOrderEditPermissions = () =>
  hasPermissions(service, endpoint, 'put')
export const hasOrderPostPermissions = () =>
  hasPermissions(service, endpoint, 'post')
